import * as React from 'react';

import {getDueUnitArray} from 'nutshell-core/date-time/delays';

import {SelectNew} from 'shells/select-new/select-new';

import type {DueDateUnit} from 'nutshell-graphql-types';

type Props = {
    value: DueDateUnit;
    isSingleUnit: boolean;
    onChange: (newValue: {id: DueDateUnit; value: string}) => void;
};

export class DueUnitPicker extends React.PureComponent<Props> {
    render() {
        return (
            <SelectNew
                valueKey='id'
                labelKey='value'
                value={{id: this.props.value}}
                onChange={this.props.onChange}
                selectValues={getDueUnitArray(this.props.isSingleUnit ? 'singular' : 'plural')}
            />
        );
    }
}
